import { Container } from "react-bootstrap";

const Mapa = () => {
    const apiKey = "AIzaSyBgZA90FJF1Abmhb1sTU6d62F6kNVQSEEI"; // o process.env.REACT_APP_GOOGLE_MAPS_KEY
    const location = "Calle Asarau 20 1º B, Castellón, España";

    return (
        <Container fluid="xxl" className="my-4 p-0 d-flex flex-column align-items-center">
            <h2>Ubicación</h2>
            <div className="mapa-container">
                <iframe
                    title="Ubicación de Manus Fortis en Castellón"
                    width="100%"
                    height="450"
                    style={{ border: 0 }}
                    referrerPolicy="no-referrer-when-downgrade"
                    src={`https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${encodeURIComponent(location)}`}
                    allowFullScreen
                    loading="lazy"
                />
            </div>
        </Container>
    );
};

export default Mapa;
